import React, { lazy, Suspense } from 'react';

import { UserProvider } from '@tv2/lib-offspring/api/user/UserProvider';
import { QueryClientProvider } from '@tv2/lib-offspring/api/graphql/QueryClientProvider';
import { getPublicRuntimeEnv } from '@tv2/lib-offspring/libs/publicEnv';
import { usePathOrDefault } from '@tv2/lib-offspring/hooks/usePath';
import { useAdmin } from './AdminProvider';

const AdminPanel = lazy(() => import('./AdminPanel'));

const env = getPublicRuntimeEnv();

export function LazyAdminPanel() {
  const { enable, isAdmin } = useAdmin();
  const path = usePathOrDefault();

  if (!enable || !path) return null;

  return (
    <Suspense fallback={null}>
      <UserProvider ssrLoggedInHint>
        <QueryClientProvider apiUrl={env.API_URL} isAdmin={isAdmin}>
          <AdminPanel />
        </QueryClientProvider>
      </UserProvider>
    </Suspense>
  );
}
